"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Plugin2 = _interopRequireDefault(require("./Plugin"));

var PIXI = _interopRequireWildcard(require("pixi.js-legacy"));

var _LoadingMode = require("../controllers/LoadingMode");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Speedometer = /*#__PURE__*/function (_Plugin) {
  _inherits(Speedometer, _Plugin);

  var _super = _createSuper(Speedometer);

  function Speedometer() {
    var _this;

    var autoHides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, Speedometer);

    _this = _super.call(this);
    _this._name = "Speedometer";
    return _this;
  }

  _createClass(Speedometer, [{
    key: "position",
    value: function position(sprite, frame, videoInfo) {
      sprite.x = 10;
      sprite.y = 10;
    }
  }, {
    key: "setup",
    value: function setup(frame, videoInfo, pixi) {
      frame.x = frame.x ? frame.x : 0;
      frame.y = frame.y ? frame.y : 0;

      _get(_getPrototypeOf(Speedometer.prototype), "setup", this).call(this, frame, videoInfo, pixi);

      if (!pixi) {
        return;
      } //this.layer = new PIXI.Graphics()


      var style = new PIXI.TextStyle({
        fill: "#e6c833",
        fontFamily: "Comic Sans MS",
        fontSize: 17,
        fontWeight: "bold",
        dropShadow: true,
        dropShadowBlur: 3
      });
      this.speedText = new PIXI.Text("--", style); //layer.addChild(this.speedText)

      this.position(this.speedText, this.safeVideoArea, videoInfo);
      this.scene.addChild(this.speedText);
    }
  }, {
    key: "update",
    value: function update(frame, videoInfo) {
      // hide until video ready
      if (!this.videoReady) {
        this.scene.visible = false;
        return;
      }

      this.scene.visible = true;

      if (this.speedText) {
        var _videoInfo$network_sp;

        var text;

        switch (videoInfo.loading_mode) {
          case _LoadingMode.LoadingMode.LOW:
            text = "LOW: ";
            break;

          case _LoadingMode.LoadingMode.MED:
            text = "MED: ";
            break;

          case _LoadingMode.LoadingMode.HIGH:
            text = "HIGH: ";
            break;

          case _LoadingMode.LoadingMode.SUPER_HIGH:
            text = "SUPER_HIGH: ";
            break;

          default:
            text = "??: ";
            break;
        }

        var speed = (_videoInfo$network_sp = videoInfo.network_speed) !== null && _videoInfo$network_sp !== void 0 ? _videoInfo$network_sp : 0;
        text += "".concat(Math.round(speed * 10) / 10, " Mbps");
        this.speedText.text = text;
        this.position(this.speedText, this.safeVideoArea, videoInfo);
      }

      if (this.isResizing) {
        this.scene.alpha = 0;
      } else {
        this.scene.alpha = 1;
      }
    }
  }]);

  return Speedometer;
}(_Plugin2.default);

exports.default = Speedometer;